/**
 * Button Response Message Factory
 * Creates standardized messages for button responses
 */

import type { ChatMessage } from '../data-layer/types';

/**
 * Create success message for continue with instructions
 */
export const createContinueSuccessMessage = (): ChatMessage => ({
  id: `continue-success-${Date.now()}`,
  type: 'ai_response',
  subType: 'success',
  text: 'Configuration saved successfully.',
  timestamp: Date.now(),
});

/**
 * Create 3-button helper message for connection step
 */
export const createConnectionHelperMessage = (): ChatMessage => ({
  id: `connection-helper-modify-${Date.now()}`,
  type: 'ai_response',
  subType: 'threeButtonsHelperText',
  timestamp: Date.now(),
  buttons: [
    { label: 'Specify Prompt', action: 'connection_help_yes' },
    { label: 'Upload Browser Recording', action: 'connection_help_yes' },
    { label: 'Skip for Now', action: 'connection_help_no' },
  ],
});

/**
 * Create 3-button helper message for account steps
 */
export const createAccountHelperMessage = (): ChatMessage => ({
  id: `account-helper-modify-${Date.now()}`,
  type: 'ai_response',
  subType: 'threeButtonsHelperText',
  timestamp: Date.now(),
  buttons: [
    { label: 'Specify Prompt', action: 'all_account_help_yes' },
    { label: 'Upload Browser Recording', action: 'all_account_help_yes' },
    { label: 'Skip for Now', action: 'all_account_help_no' },
  ],
});
